export default "__VITE_ASSET__C9xXbJ$L__"